<!-- Campo de busca -->
<mat-form-field>
  <mat-label>{{
    "find-carworkshop-maps.set-reference-point" | translate
  }}</mat-label
  ><input
    #search
    matInput
    required
    type="search"
    autocorrect="off"
    autocapitalize="off"
    autocomplete="off"
    spellcheck="off"
    [formControl]="searchPlaceInput"
    (keydown.enter)="$event.preventDefault()"
    (keydown.esc)="getAddress(center.lat, center.lng)"
    [matAutocomplete]="mapsAutocomplete"
  />
  <mat-autocomplete #mapsAutocomplete="matAutocomplete" autoActiveFirstOption>
    <mat-option
      class="autocomplete"
      *ngFor="let result of results$ | async"
      [value]="result.description"
      (onSelectionChange)="placeChanged(result)"
    >
      <i
        *ngIf="result.type === 'carworkshop'"
        [style]="{ color: '#007BC0' }"
        class="bosch-ic bosch-ic-car-steering-right"
      ></i>
      <i
        *ngIf="result.type === 'mappoint'"
        [style]="{ color: '#007BC0' }"
        class="bosch-ic bosch-ic-locator"
      ></i>
      {{ result.description }}
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="searchPlaceInput.hasError('required')">{{
    "find-carworkshop-maps.required-field" | translate
  }}</mat-error>
</mat-form-field>

<!-- Mapa Google Maps atualizado -->
<div class="map-container" *ngIf="!loadingMap && isGoogleMapsLoaded">
  <google-map
    [center]="center"
    [zoom]="zoom"
    [options]="mapOptions"
    width="100%"
    height="400px"
  >
    <!-- Marcador do usuário -->
    <map-marker
      *ngIf="userMarker"
      [position]="userMarker.position"
      [options]="userMarker.options"
    ></map-marker>

    <!-- Marcadores das oficinas do histórico -->
    <map-marker
      *ngFor="let carworkshop of historyCarworkshop"
      [position]="{ lat: carworkshop.latitude, lng: carworkshop.longitude }"
      [options]="{
        icon: {
          url: getCustomPinMap(carworkshop.id),
          scaledSize: { width: 60, height: 60 }
        }
      }"
      (mapClick)="selectCarworkshop(carworkshop)"
    ></map-marker>

    <!-- Marcadores das oficinas próximas -->
    <map-marker
      *ngFor="let carworkshop of nearbiesCarworkshop"
      [position]="{ lat: carworkshop.latitude, lng: carworkshop.longitude }"
      [options]="{
        icon: {
          url: getCustomPinMap(carworkshop.id),
          scaledSize: { width: 60, height: 60 }
        }
      }"
      (mapClick)="selectCarworkshop(carworkshop)"
    ></map-marker>
  </google-map>
</div>

<!-- Loading do mapa -->
<div *ngIf="loadingMap" class="map-loading">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<div class="network-autocomplete">
  <app-driveb-multiple-network-autocomplete
    style="width: 100%"
    (onNetworkSelection)="handleNetworkSelection($event)"
    *ngIf="center.lng && center.lat"
  >
  </app-driveb-multiple-network-autocomplete>
</div>

<div
  class="carkworkshops-content"
  [ngStyle]="{
    'justify-content': loadingCarworkshops ? 'center' : 'space-between'
  }"
>
  <ng-container
    *ngIf="
      (nearbiesCarworkshop.length || historyCarworkshop.length) &&
      !loadingCarworkshops
    "
  >
    <div class="side-content">
      <p class="title">
        {{ "find-carworkshop-maps.carworkshop-history" | translate }}
      </p>
      <div class="border-container">
        <p
          *ngIf="
            nearbiesCarworkshop.length &&
            !historyCarworkshop.length &&
            searched &&
            !loadingCarworkshops
          "
          class="not-found"
        >
          {{
            "find-carworkshop-maps.no-carworkshop-found-with-filter" | translate
          }}
        </p>

        <div
          *ngFor="let carworkshop of historyCarworkshop"
          class="carworkshop history"
          (click)="
            carworkshop.provideDesiredServices &&
            carworkshop.acceptVehicleBrand &&
            carworkshop.provideServiceType
              ? selectCarworkshop(carworkshop)
              : null
          "
          matTooltipShowDelay="0"
          matTooltipHideDelay="0"
          [matTooltip]="
            !carworkshop.provideDesiredServices ||
            !carworkshop.acceptVehicleBrand ||
            !carworkshop.provideServiceType
              ? ('find-carworkshop-maps.carworkshop-not-meet-type-service-requested'
                | translate)
              : null
          "
          [ngClass]="{
            selected: carworkshop.id === selectedCarworkshopId,
            disabled:
              !carworkshop.provideDesiredServices ||
              !carworkshop.acceptVehicleBrand ||
              !carworkshop.provideServiceType
          }"
        >
          <div class="first-box history-content">
            <p>{{ carworkshop.tradingName }}</p>
            <p>
              {{ carworkshop.address.street }},
              {{ carworkshop.address.number }} - {{ carworkshop.address.city }}
            </p>
            <p
              *ngIf="serviceType === 'PREVENTIVE' && clientIsNewPreventiveFlow"
            >
              {{ "find-carworkshop-maps.reference-value" | translate }}:
              {{
                carworkshop.maintenancePrice
                  ? carworkshop.maintenancePrice
                  : ("find-carworkshop-maps.unavailable" | translate)
              }}
            </p>
          </div>
          <div class="second-box">
            <mat-chip class="tag" *ngIf="carworkshop.networkName"
              ><p>{{ carworkshop.networkName }}</p></mat-chip
            >
            <p>
              ({{ "find-carworkshop-maps.last-service" | translate }}:
              {{ carworkshop.serviceCompletionDate | date }})
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="side-content">
      <p class="title">
        {{ "find-carworkshop-maps.nearby-carworkshops" | translate }}
      </p>
      <div class="infinite-scroll-container" (scroll)="onScroll($event)">
        <p
          *ngIf="
            !nearbiesCarworkshop.length &&
            historyCarworkshop.length &&
            searched &&
            !loadingCarworkshops
          "
          class="not-found"
        >
          {{
            "find-carworkshop-maps.no-carworkshop-found-with-filter" | translate
          }}
        </p>
        <div
          *ngFor="let carworkshop of nearbiesCarworkshop"
          class="carworkshop nearby"
          (click)="selectCarworkshop(carworkshop)"
          [ngClass]="{ selected: carworkshop.id === selectedCarworkshopId }"
        >
          <div class="first-box nearby-content">
            <p>{{ carworkshop.tradingName }}</p>
            <p>
              {{ carworkshop.address.street }},
              {{ carworkshop.address.number }} - {{ carworkshop.address.city }}
            </p>
            <p
              *ngIf="serviceType === 'PREVENTIVE' && clientIsNewPreventiveFlow"
            >
              {{ "find-carworkshop-maps.reference-value" | translate }}:
              {{
                carworkshop.maintenancePrice
                  ? carworkshop.maintenancePrice
                  : ("find-carworkshop-maps.unavailable" | translate)
              }}
            </p>
          </div>
          <div class="second-box">
            <mat-chip class="tag" *ngIf="carworkshop.networkName"
              ><p>{{ carworkshop.networkName }}</p></mat-chip
            >
            <p>
              ({{ "find-carworkshop-maps.distance" | translate }}:
              {{ carworkshop.distance }} {{ mileageUnit }})
            </p>
          </div>
        </div>

        <!-- Loading para scroll infinito -->
        <div *ngIf="isLoadingNearby" class="loading-more">
          <mat-spinner diameter="30"></mat-spinner>
        </div>
      </div>
    </div>
  </ng-container>

  <p
    *ngIf="
      !nearbiesCarworkshop.length &&
      !historyCarworkshop.length &&
      searched &&
      !loadingCarworkshops
    "
    class="not-found"
  >
    {{ "find-carworkshop-maps.no-carworkshop-found-with-filter" | translate }}
  </p>

  <!-- Loading geral das oficinas -->
  <div *ngIf="loadingCarworkshops" class="loading-carworkshops">
    <mat-spinner diameter="50"></mat-spinner>
    <span>{{ "find-carworkshop-maps.loading-carworkshops" | translate }}</span>
  </div>
</div>
